import { memo } from 'react';
import { inputCls } from './utils/inputCls';

interface AnalyticsFormProps {
  gaId: string;
  startDate: string;
  endDate: string;
  loading: boolean;
  error: string | null;
  onGaIdChange: (value: string) => void;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onDismissError: () => void;
}

const AnalyticsForm = memo(({
  gaId,
  startDate,
  endDate,
  loading,
  error,
  onGaIdChange,
  onStartDateChange,
  onEndDateChange,
  onSubmit,
  onDismissError,
}: AnalyticsFormProps) => (
  <>
    <form onSubmit={onSubmit} className="px-6 py-5 flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <label
          htmlFor="gaId"
          className="text-xs font-semibold text-black uppercase tracking-wide"
        >
          GA Property ID
        </label>
        <input
          id="gaId"
          type="text"
          value={gaId}
          onChange={(e) => onGaIdChange(e.target.value)}
          placeholder="GA-263109122"
          disabled={loading}
          className={inputCls}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="flex flex-col gap-1.5">
          <label
            htmlFor="startDate"
            className="text-xs font-semibold text-black uppercase tracking-wide"
          >
            Date de début
          </label>
          <input
            id="startDate"
            type="date"
            value={startDate}
            max={endDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            disabled={loading}
            className={inputCls}
          />
        </div>

        <div className="flex flex-col gap-1.5">
          <label
            htmlFor="endDate"
            className="text-xs font-semibold text-black uppercase tracking-wide"
          >
            Date de fin
          </label>
          <input
            id="endDate"
            type="date"
            value={endDate}
            min={startDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            disabled={loading}
            className={inputCls}
          />
        </div>
      </div>

      <button
        type="submit"
        disabled={loading || !gaId || !startDate || !endDate}
        className="w-full py-3 rounded-xl text-sm font-semibold text-black border-none
                   cursor-pointer bg-gradient-to-r from-orange-500 to-orange-300
                   shadow-md shadow-blue-200 hover:brightness-105 hover:-translate-y-0.5
                   transition-all duration-200
                   disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
      >
        Charger les Analytics Avancées
      </button>
    </form>

    {error && (
      <div
        className="flex items-center gap-3 mx-6 mt-4
                   bg-rose-50 border border-rose-200 rounded-xl px-4 py-3 text-rose-600 text-sm"
      >
        <span>⚠️</span>
        <span className="flex-1">{error}</span>
        <button
          onClick={onDismissError}
          className="w-6 h-6 flex items-center justify-center rounded-lg
                     bg-rose-100 hover:bg-rose-200 text-rose-500 border-none
                     cursor-pointer hover:rotate-90 transition-all duration-200"
        >
          ×
        </button>
      </div>
    )}
  </>
));

AnalyticsForm.displayName = 'AnalyticsForm';

export default AnalyticsForm;